import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';

import classes from './ClaimBingoAnimation.module.scss';
import { ClaimBingoRiveAnimation } from './ClaimBingoRiveAnimation/ClaimBingoRiveAnimation';

function ClaimBingoAnimationComponent() {
  const { bingoStore } = useStores();
  const { claimBingoAnimationState } = bingoStore;

  if (!claimBingoAnimationState.enable) {
    return null;
  }

  const animationKey = `${claimBingoAnimationState.coinType}-${claimBingoAnimationState.bingoAmount}`;

  return (
    <div className={classes.claimBingoAnimation}>
      <ClaimBingoRiveAnimation
        key={animationKey}
        amount={claimBingoAnimationState.bingoAmount}
        input={claimBingoAnimationState.coinType === 'CASH' ? 'green' : 'yellow'}
        onAnimationEnd={() => {
          claimBingoAnimationState.onAnimationEnd?.();
        }}
      />
    </div>
  );
}

export const ClaimBingoAnimation = observer(ClaimBingoAnimationComponent);
